import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from './store/store';
import { createSocket } from './utils/socketManager';
const WebSocketInitializer = () => {
  const user = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();
  useEffect(() => {
    if (user.id) {
      createSocket(user, dispatch);
    }
  }, [user, dispatch]);
  return null;
};
export default WebSocketInitializer;
